import React, { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';
const Wrapper = styled.div `
  .quill {
    display: flex;
    flex-direction: column-reverse;
  }
  .ql-container {
    border: none !important;
  }

  .ql-editor {
    height: 148px;
    overflow-y: auto;
    background-color: #f4f4f8;
    font-family: 'Sarala', sans-serif;
  }
  .ql-editor::-webkit-scrollbar {
    background-color: white;
    height: 119px;
    width: 12px;
  }
  .ql-editor::-webkit-scrollbar-thumb:vertical {
    background-color: #c4c4c4;
    border-radius: 16px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  .ql-toolbar {
    border: none !important;
    background-color: #f4f4f8;
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .ql-toolbar > button {
    height: 15px;
    padding: 0;
  }
  .ql-formats > button {
    @media (max-width: 500px) {
      height: 25px !important;
      margin: 10px !important;
    }
  }
`;
const TextEditor = ({ name, value, placeholder, onChange, onBlur, }) => {
    useEffect(() => {
        if (value) {
            onBlur();
        }
    }, []);
    const reactQuillRef = useRef();
    const maxMessageLength = 10000;
    const handleChange = (newValue, delta, source) => {
        if (source === 'user') {
            onChange(newValue);
        }
    };
    const checkMessageLength = (event) => {
        if (reactQuillRef.current) {
            const messageLength = reactQuillRef.current.unprivilegedEditor.getLength();
            if (messageLength > maxMessageLength && event.key !== 'Backspace') {
                event.preventDefault();
            }
        }
    };
    const handleBlur = (range, source, quill) => {
        onBlur(quill.getHTML());
    };
    const enabledModules = {
        toolbar: [['bold', 'italic', 'underline'], [{ list: 'bullet' }]],
    };
    const enabledFormats = ['bold', 'italic', 'underline', 'list', 'bullet'];
    return (React.createElement(Wrapper, { name: name },
        React.createElement(ReactQuill, { placeholder: placeholder, onKeyDown: checkMessageLength, ref: reactQuillRef, theme: "snow", modules: enabledModules, formats: enabledFormats, value: value, onChange: handleChange, onBlur: handleBlur })));
};
export default TextEditor;
